/**
 * Sanitize a returnTo query param, exactly mirroring the mobile rules at
 * `src/utils/authReturnTo.ts:12-27`. Any change here must be matched there.
 *
 * Rules:
 *   - must decode without throwing
 *   - must start with `/`
 *   - must NOT start with `//` (rejects protocol-relative URLs)
 *   - must NOT start with `/(auth)` or `/onboarding` (route segregation)
 */
export function sanitizeReturnTo(raw: string | null | undefined): string | null {
  if (!raw) return null;

  let decoded = raw;
  try {
    decoded = decodeURIComponent(raw);
  } catch {
    decoded = raw;
  }

  if (!decoded.startsWith('/') || decoded.startsWith('//')) return null;
  if (decoded.startsWith('/(auth)') || decoded.startsWith('/onboarding')) return null;

  return decoded;
}
